module.exports = __webpack_public_path__ + "static/media/icd-logo.f2d7d3db.png";